import * as Sentry from '@sentry/react';
import { PropsWithChildren } from 'react';
import ErrorPage from '../ErrorPage/ErrorPage';
import { tw } from '@/lib/tailwind';

function FallbackComponent({ error, resetError }: { error: Error; resetError: () => void }) {
  return (
    <ErrorPage
      status={500}
      message={error.message}
    >
      <div className="flex gap-2">
        <button
          onClick={resetError}
          className={tw('text-primary-700 cursor-pointer border-0 bg-none p-0 text-xs')}
        >
          Try Again
        </button>
        <button
          onClick={() => window.location.reload()}
          className={tw('text-primary-700 cursor-pointer border-0 bg-none p-0 text-xs')}
        >
          Reload Page
        </button>
      </div>
    </ErrorPage>
  );
}

export function SentryErrorBoundary({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary
      fallback={(props) => (
        <FallbackComponent
          error={props.error as Error}
          resetError={props.resetError}
        />
      )}
      showDialog={false} // Set to false to ensure we see our fallback first
      beforeCapture={(scope) => {
        scope.setTag('location', 'dashboard');
        scope.setLevel('error');
      }}
      onError={(error) => {
        console.error('[SentryErrorBoundary] Caught error:', error);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
